// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

.main-content {
  flex: 1 1;
  padding: 30px 0;
}

.content-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;
  margin-top: 20px;
}

.notice-list-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.notice-detail-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.loading {
  text-align: center;
  padding: 50px;
  font-size: 18px;
  color: #666;
}

.footer {
  background-color: #2c3e50;
  color: white;
  padding: 30px 0;
  text-align: center;
  margin-top: auto;
}

.footer p {
  margin: 5px 0;
  font-size: 14px;
}

@media (min-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1fr 1fr;
  }
}

@media print {
  .header,
  .search-bar,
  .notice-list-section,
  .footer,
  .print-button {
    display: none !important;
  }
  
  .main-content {
    padding: 0;
  }
  
  .content-wrapper {
    display: block;
  }
  
  .notice-detail-section {
    box-shadow: none;
    padding: 0;
  }
  
  body {
    background: white;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  width: 100%;\n}\n\n.main-content {\n  flex: 1;\n  padding: 30px 0;\n}\n\n.content-wrapper {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 30px;\n  margin-top: 20px;\n}\n\n.notice-list-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.notice-detail-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.loading {\n  text-align: center;\n  padding: 50px;\n  font-size: 18px;\n  color: #666;\n}\n\n.footer {\n  background-color: #2c3e50;\n  color: white;\n  padding: 30px 0;\n  text-align: center;\n  margin-top: auto;\n}\n\n.footer p {\n  margin: 5px 0;\n  font-size: 14px;\n}\n\n@media (min-width: 1024px) {\n  .content-wrapper {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media print {\n  .header,\n  .search-bar,\n  .notice-list-section,\n  .footer,\n  .print-button {\n    display: none !important;\n  }\n  \n  .main-content {\n    padding: 0;\n  }\n  \n  .content-wrapper {\n    display: block;\n  }\n  \n  .notice-detail-section {\n    box-shadow: none;\n    padding: 0;\n  }\n  \n  body {\n    background: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
